// extracted by mini-css-extract-plugin
export var indeterminate = "_3v-6";
export var md = "_3v-5";
export var semantic = "_3v-7";
export var sm = "_3v-4";
export var text = "_3v-8";
export var toggleControl = "_3v-0";
export var toggleInput = "_3v-1";
export var toggleSwitch = "_3v-2";
export var xs = "_3v-3";